import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { HtmlRenderer, Parser } from 'commonmark';
const FreeTextRegex = /\$(\w+)\$/g; // Matches $word$
const ImageRegex = /!\[([^\]]*)]\((http[s]?:\/\/[^\)]+)\)/g; // Matches ![altText](imageUrl)
const LinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g; // Matches [linkText](url)
const YoutubeRegex = /\[\]\((https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9_-]+))\)/g; // Matches [](https://www.youtube.com/watch?v=videoId)
export const ParseMarkDownText = (text) => {
    const processedText = replaceWithListItems(text)
        .replace(FreeTextRegex, '<strong style="color: #f60;">$1</strong>')
        .replace(ImageRegex, (_match, altText, imageUrl) => {
        return `<img src="${imageUrl}" alt="${altText}" width="100%" />`;
    })
        .replace(LinkRegex, '<a href="$2">$1</a>')
        .replace(YoutubeRegex, (_match, _url, videoId) => {
        return `<div class="iFrameContainer"><iframe src="https://www.youtube.com/embed/${videoId}" title="explanation video"></iframe></div>`;
    });
    const reader = new Parser();
    const writer = new HtmlRenderer();
    const parsed = reader.parse(processedText);
    const result = writer.render(parsed);
    return _jsx(StyledMarkdown, { HTML: result });
};
const replaceWithListItems = (text) => {
    const lines = text.split(/\r?\n/);
    const result = [];
    let insideList = false;
    lines.forEach(line => {
        if (line.startsWith('v ')) {
            if (!insideList) {
                result.push('<ul>');
                insideList = true;
            }
            result.push(`<li class="markdown__list-item-usp markdown__list_item">${line.substring(2)}</li>`);
        }
        else if (line.startsWith('+ ')) {
            if (!insideList) {
                result.push('<ul>');
                insideList = true;
            }
            result.push(`<li class="markdown__list-item-pro markdown__list_item">${line.substring(2)}</li>`);
        }
        else if (line.startsWith('- ')) {
            if (!insideList) {
                result.push('<ul>');
                insideList = true;
            }
            result.push(`<li class="markdown__list-item-con markdown__list_item">${line.substring(2)}</li>`);
        }
        else {
            if (insideList) {
                result.push('</ul>');
                insideList = false;
            }
            result.push(line);
        }
    });
    if (insideList) {
        result.push('</ul>');
    }
    return result.join('\r\n');
};
const StyledMarkdown = ({ HTML }) => {
    const Styled = styled.div(({ theme }) => `
    ul {
      padding-bottom: ${theme.spacing[400]};
      padding-left: ${theme.spacing[600]};
      margin: 0;

      &:last-child {
        padding-bottom: 0;
      }

      .markdown__list_item {
        list-style-type: none;
        margin-bottom: ${theme.spacing[100]};

        &::before {
          content: '';
          float: left;
          height: ${theme.spacing[400]};
          margin-left: calc(${theme.spacing[600]} * -1);
          margin-top: 0.2rem;
          width: ${theme.spacing[400]};
        }
      }

      .markdown__list-item-usp {
        &::before {
          background: url('https://assets.coolblue.nl/images/icons/icon_checkmark.svg') no-repeat;
        }
      }

      .markdown__list-item-pro {
        &::before {
          background: url('https://assets.coolblue.nl/images/icons/icon_plus.svg') no-repeat;
        }
      }

      .markdown__list-item-con {
        &::before {
          background: url('https://assets.coolblue.nl/images/icons/icon_minus.svg') no-repeat;
        }
      }
    }

    a {
      color: ${theme.color.font.interactiveBase};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border: none;
    }

    .iFrameContainer {
      background-color: ${theme.color.background.secondary};
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
      position: relative;
      border-radius: ${theme.borderRadius[100]};
    }
  `);
    return _jsx(Styled, { dangerouslySetInnerHTML: { __html: HTML } });
};
//# sourceMappingURL=ParseMarkDownText.js.map